import { API } from "@/lib/api";

const toDataUrl = async (url) => {
  const res = await fetch(url);
  if (!res.ok) throw new Error("photo");
  const blob = await res.blob();
  return new Promise((resolve) => { const r = new FileReader(); r.onload = () => resolve(r.result); r.readAsDataURL(blob); });
};

const imgSize = (dataUrl) => new Promise((resolve) => { const i = new Image(); i.onload = () => resolve([i.width, i.height]); i.onerror = () => resolve([4, 3]); i.src = dataUrl; });

export async function exportNotesReport(notes, { title = "Field Notes Report", author = "" } = {}) {
  const { jsPDF } = await import("jspdf");
  const token = localStorage.getItem("cgland_token");
  const pdf = new jsPDF({ unit: "mm", format: "a4" });
  const W = 210, M = 16, CW = W - 2 * M;
  let y = M;
  const line = (text, size = 10, style = "normal", color = 30) => {
    pdf.setFontSize(size); pdf.setFont("helvetica", style); pdf.setTextColor(color);
    const rows = pdf.splitTextToSize(text, CW);
    rows.forEach((r) => { if (y > 280) { pdf.addPage(); y = M; } pdf.text(r, M, y); y += size * 0.5; });
  };
  pdf.setFillColor(15, 81, 50); pdf.rect(0, 0, W, 28, "F");
  pdf.setTextColor(255); pdf.setFontSize(18); pdf.setFont("helvetica", "bold"); pdf.text("CG Land Geoportal", M, 12);
  pdf.setFontSize(11); pdf.setFont("helvetica", "normal"); pdf.text(title, M, 20);
  y = 38;
  line(`Generated ${new Date().toLocaleString("en-IN")}${author ? ` · ${author}` : ""} · ${notes.length} note${notes.length === 1 ? "" : "s"}`, 9, "normal", 110);
  y += 4;
  for (let i = 0; i < notes.length; i++) {
    const n = notes[i];
    if (y > 240) { pdf.addPage(); y = M; }
    pdf.setDrawColor(200, 90, 50); pdf.setLineWidth(0.8); pdf.line(M, y, M + 12, y); y += 5;
    line(`${i + 1}. ${new Date(n.created_at).toLocaleString("en-IN")}${n.user_email ? ` · ${n.user_email}` : ""}`, 11, "bold");
    line(`${n.lat.toFixed(6)}, ${n.lng.toFixed(6)}${n.accuracy ? ` · GPS ±${Math.round(n.accuracy)} m` : ""}`, 9, "normal", 110);
    if (n.text) { y += 1; line(n.text, 10); }
    if (n.has_photo) {
      try {
        const dataUrl = await toDataUrl(`${API}/map/notes/${n.id}/photo?auth=${token}${n.user_email ? "&scope=admin" : ""}`);
        const [iw, ih] = await imgSize(dataUrl);
        const w = Math.min(CW, 120), h = (w * ih) / iw;
        if (y + h > 285) { pdf.addPage(); y = M; }
        pdf.addImage(dataUrl, dataUrl.startsWith("data:image/png") ? "PNG" : "JPEG", M, y + 2, w, h);
        y += h + 6;
      } catch { line("(photo unavailable)", 9, "italic", 150); }
    }
    y += 6;
  }
  const pages = pdf.getNumberOfPages();
  for (let p = 1; p <= pages; p++) { pdf.setPage(p); pdf.setFontSize(8); pdf.setTextColor(150); pdf.text(`CG Land Geoportal · ${title} · page ${p}/${pages}`, M, 292); }
  pdf.save(`cgland-field-notes-${new Date().toISOString().slice(0, 10)}.pdf`);
}
